export default "https://cdn-static.gokick.com/assets/6909edbc169b94fbe838446b12805066cb856688/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";